<template>
  <div id="LayTranslate">
    <div class="LayTranslatelist">
      <div class="left_Title">
        <p>
          <i class="iconfont iconjieguo"></i>
          <span
              class="aqt_lang_mn titlefont">{{ $t('m.translationresults') + '&nbsp;' + '(' + total + ')'  |U2M }}</span>
        </p>
        <p></p>
      </div>
      <div v-if="!isNo" class="m_content" ref="Content_Width">
        <!-- 主题内容页 -->
        <div class="history aqt_su">

          <div class="main" v-for="(elem,i) of list" :key="i">

            <p class="tm" ref="tkuan">
              <span v-if="connect.language=='zh'" v-html="U2M(elem.title)" style="margin-top: -0.7rem"></span>
              <span v-else class="aqt_lang_mn titlefont" v-html="U2M(elem.title)" style="margin-top: 1rem"></span>
            </p>
            <div class="preface_box" v-if="elem.imgs.length||elem.videos.length||elem.audios.length"
                 style="padding: 5px 0 5px 0;">
              <div class="preface_box_picture" v-if="elem.imgs.length">
                <div class="picture_size" v-for="(item,index) in elem.imgs" :key="index+9087">
                  <el-image
                      style="width: 100%;height: 100%"
                      :src="item?$webcrypto.get(item):''"
                      :preview-src-list="elem.showImgs">
                  </el-image>
                </div>
              </div>
              <div class="preface_box_video" v-if="elem.videos.length">
                <div class="video_size" v-for="(item,index) in elem.videos" :key="index+9087"
                     @click="getVideo(item,'preface')">
                  <img class="imgbag" :src="item.videopic?$webcrypto.get(item.videopic):''">
                  <i class="iconfont iconbofang"></i>
                </div>
              </div>
              <div class="preface_box_audio" v-if="elem.audios.length">
                <p class="audio_size" v-for="(ite,indd) in elem.audios" :key="indd+4567"
                   @click.stop="getAudioInfo(ite,indd,'preface')"
                   style="border-left: 2px solid #F5F5F5">
                  <span class=" aqt_lang_mn titlefont" v-html="matchChinese(U2M($DeleteFileName(ite.name)))"></span>
                </p>
              </div>
            </div>


            <div v-if="elem.child.length" v-for="(el,j) in elem.child" :key="j+8879" style="margin-right: 8px">

              <p class="om aqt_lang_mn titlefont" style="display: flex;flex-wrap: wrap;font-size: 1.4rem;line-height: 15px">
                <span v-for="(its,sde) in el.yinbiaolang" v-if="its" >{{' [ '+ its +' ] '}}</span>
              </p>
              <p ref="okuan" class="om aqt_lang_mn titlefont" v-for="(it,ind) in el.contentlang"
                 v-html="matchChinese(U2M($TextConversion(it)))"></p>

              <div class="preface_box" v-if="el.conimgs.length||el.convideos.length||el.conaudios.length"
                   style="padding: 2.5rem 0;">
                <div class="preface_box_picture" v-if="el.conimgs.length">
                  <div class="picture_size" v-for="(item,index) in el.conimgs" :key="index+98">
                    <el-image
                        style="width: 100%;height: 100%"
                        :src="item?$webcrypto.get(item):''"
                        :preview-src-list="el.showImgs">
                    </el-image>
                  </div>
                </div>
                <div class="preface_box_video" v-if="el.convideos.length">
                  <div class="video_size" v-for="(item,index) in el.convideos" :key="index+345"
                       @click="getVideo(item,'content')">
                    <img class="imgbag" :src="item.videopic?$webcrypto.get(item.videopic):''">
                    <i class="iconfont iconbofang"></i>
                  </div>
                </div>
                <div class="preface_box_audio" v-if="el.conaudios.length">
                  <p class="audio_size" v-for="(ite,indd) in el.conaudios" :key="indd+22"
                     @click.stop="getAudioInfo(ite,indd,'content')"
                     style="border-left: 2px solid #F5F5F5">
                    <span class=" aqt_lang_mn titlefont" v-html="matchChinese(U2M($DeleteFileName(ite.name)))"></span>
                  </p>
                </div>
              </div>


              <!--              <span class="aqt_lang_mn titlefont ly" ref="dkuan2">{{ elem.form_namelang.mn|U2M }}</span>-->
              <!--pointer-->
              <span @click="bookinfo(el.book_id,el.book_language)" v-if="el.book_id"
                    class="ly" :class="el.form_namelang.mn?'aqt_lang_mn titlefont':''"
                    :style="{color:el.book_language.includes('mn')?'var(--themeColor)':'', cursor:el.book_language.includes('mn')?'':'',
                borderRight:el.book_language.includes('mn')? '1px solid var(--themeColor)':'1px solid #888888',}">{{
                  el.form_namelang.mn || el.form_namelang.zh |U2M
                }}&nbsp;&nbsp;{{ el.bookmun ? '(' + el.bookmun + ')' : '' }}</span>


            </div>
          </div>

        </div>

      </div>
      <div class="page">
        <PageMn v-if="!isNo" :total="total" :current="current_page"
              :pageSize="per_page" @getPager="getPager">
        </PageMn>
        <!-- <Page v-if="!isNo" :total="total" :current="current_page"
              :page-size="per_page"
              @on-change="getPager"/> -->
      </div>
      <div v-if="isNo&&!list.length" class="nomassage">
        <p class="aqt_lang_mn titlefont">{{ $t('m.noData') | U2M }}</p>
      </div>
      <!--    加载动画-->
      <AqtSpin v-if="isSpin"></AqtSpin>
    </div>
    <file_preview style="display:none" :file_name="videoUrl" ref="file_preview"></file_preview>
  </div>
</template>

<script>
export default {
  name: 'LayTranslate_name',
  data() {
    return {
      total: 0,
      current_page: 1,
      per_page: 0,
      list: [],
      isNo: false,
      connect: {
        per_page: '',
        class_id: 150,
        page: 1,
        title: "",
        language: 'mn',//开始语言
        conlanguage: '',//结束语言
      },
      isSpin: false,
      videoUrl: '',
    }
  },
  methods: {
    getPreview(data) {
      this.videoUrl = data
      setTimeout(() => {
        this.$refs.file_preview.preview();
      }, 500)
    },
    bookinfo(book_id, book_language) {
      return
      if (book_id && book_language.includes('mn')) {
        this.$router.push({
          path: '/BookDetails',
          query: {
            id: this.$crypto.set(book_id),
            title_left: JSON.stringify(this.$crypto.get(this.$t('m.translationresults'))),
            lib_type:sessionStorage.getItem('gcm')
          },
        });
      }
    },
    /******************************************
     *
     *分页器
     *
     *****************************************/
    getPager(page) {
      let that = this
      that.list = []
      that.connect.page = page
      that.getList()
    },
    getList() {
      let that = this
      that.isSpin = true
      that.list = []
      that.$httpsencrypt.post(`api/web/v3/dictdata/listnew`, that.connect)
          .then((val) => {
            if (val.code == 200 && val.data.length) {
              that.total = val.pages.total
              that.current_page = val.pages.current_page
              that.per_page = val.pages.per_page * 1
              that.list = that.processData(val.data);

              that.isSpin = false
              that.isNo = false
            } else {
              that.list = []
              thst.isNo = true
              that.isSpin = false
              that.total = 0
            }

          }).catch(e => {
            that.list = []
            that.isNo = true
            that.isSpin = false
            that.total = 0
          }
      )
    },
    /************************************************************
     * 处理数据
     ************************************************************/
    matchChinese(str) {
      if (!str) {
        return str;
      }
      let arr = str.split(" ");
      // let reg = /[\u4e00-\u9fa5\u3000-\u303f]/g; //中文+中文符合
      let reg = /[\u4e00-\u9fa5]/g; //中文
      let strarr = str.match(reg)

      if (arr.length && strarr && strarr.length) {
        strarr.forEach(element => {
          let replacestr = ''
          let search = new RegExp(element, 'g');
          replacestr = `<span style="writing-mode:horizontal-tb!important;display: contents!important;">${element}</span>`
          str = str.replace(search, replacestr);
        });
      }
      return str
    },
    processData(data) {
      let that = this;
      data.forEach((item, index) => {
        let str = that.connect.title.trim();
        if (that.connect.language == 'zh') {
          item.title = '【' + that.$dataLight(item.title, 'zh', str) + '】';
        }
        if (that.connect.language == 'mn') {
          item.title = '【' + that.$dataLight(item.title, 'mn', str) + '】';
        }

        if (item.imgs && item.imgs.length) {
          data[index].showImgs = item.imgs.map(j => {
            return that.$webcrypto.get(j)
          })
        }
        if (item.child && item.child.length) {
          item.child.forEach((el, ind) => {
            if (el.conimgs && el.conimgs.length) {
              item.child[ind].showImgs = el.conimgs.map(j => {
                return that.$webcrypto.get(j)
              })
            }
          })
        }
      });
      return data;
    },
    //视频播放
    getVideo(val, type) {
      let that = this
      that.getVideoResources(val.resources_id, type)
    },
    //视频请求资源
    getVideoResources(resourcesId, type) {
      let that = this
      that.isFirst = 0
      let condition = {
        model: type == 'preface' ? 'DictPreface' : (type == 'content' ? 'DictContent' : ''),
        filetype: 'Video',
        level: 'AQT_2023_2',
        id: resourcesId,
        type1: type == 'preface' ? 65 : (type == 'content' ? 66 : ''),
        lang: 'mn',
        name: '点击词典大数据' + (type == 'preface' ? '头词' : (type == 'content' ? '解释' : '')) + '视频播放按钮',
      }
      that.isSpin = true
      that.$getResources(condition).then((val) => {
        if (val.code == 200) {

          let videoUrl = that.$webcrypto.get(val.data)
          if (videoUrl) {
            this.videoUrl = videoUrl
            setTimeout(() => {
              that.saveUserBehavior((type == 'preface' ? 65 : (type == 'content' ? 66 : '')), (type == 'preface' ? '头词' : (type == 'content' ? '解释' : '') + '视频播放'), resourcesId)
              this.$refs.file_preview.preview();
            }, 500)

          } else {
            that.isSpin = false
          }
        } else {
          that.$Message.warning(val.message)
        }
        that.isSpin = false

      })
          .catch((err) => {
            that.isSpin = false
          });
    },

    getAudioInfo(val, index, type) {
      let that = this
      that.getMusUrl(val, type)
    },
    /********************************************************
     * 获取音频
     **********************************************************/
    getMusUrl(info, type) {
      let that = this

      that.isSpin = true
      let condition = {
        model: type == 'preface' ? 'DictPreface' : (type == 'content' ? 'DictContent' : ''),
        filetype: 'Audio',
        level: 'AQT_2023_2',
        id: info.resources_id,
        type1: type == 'preface' ? 67 : (type == 'content' ? 68 : ''),
        lang: 'mn',
        name: '点击词典大数据' + (type == 'preface' ? '头词' : (type == 'content' ? '解释' : '')) + '音频播放按钮',
      }
      that.$getResources(condition).then((val) => {
        if (val.code == 200) {
          let MusicUrl = that.$webcrypto.get(val.data)
          if (MusicUrl) {
            this.videoUrl = MusicUrl
            setTimeout(() => {
              that.saveUserBehavior(type == 'preface' ? 67 : (type == 'content' ? 68 : ''), (type == 'preface' ? '头词' : (type == 'content' ? '解释' : '') + '音频播放'), info.resources_id)
              this.$refs.file_preview.preview();
            }, 500)
          }
        } else {
          that.$Message.warning(val.message)
        }
        that.isSpin = false
        that.showLoding = false;
      }).catch((err) => {
        that.showLoding = false;
        that.isSpin = false
      });
    },
    // 记录操作
    saveUserBehavior(type, mark, id) {
      let info = {
        book_id: id,
        magazine_id: null,
        type: type,
        path: this.$route.path,
        mark: mark,
      }
      this.$store.dispatch('saveUserBehavior', info).then(() => {
      })
    },
    //父组件调用请求数组
    ParentCom(val){
      let that = this
      that.isNo = false
      that.connect.title=val.title
      that.connect.language=val.language
      that.connect.conlanguage=val.conlanguage
      that.getList()
    },

  },

  created() {
    let info={
      type: 16,
      path: this.$route.path,
      mark: '词典数据库（翻译）',
    }
    this.$store.dispatch('saveUserBehavior', info).then(() => {
    })
  },
  mounted() {
    let that = this
    let kk = that.$refs.Content_Width.clientWidth / 84.2
    that.connect.per_page = Math.floor(kk)
  },


}
</script>

<style lang="less" scoped>
#LayTranslate {
  width: 100%;
  height: 100%;
  display: flex;
  .LayTranslatelist {
    height: 100%;
    width: 100%;
    overflow-x: auto;
    padding: 30px 0;
    display: flex;
    position: relative;

    .contentfonts1 {
      font-size: 1.6rem;
    }

    .nomassage {
      padding: 0 1rem;
      -ms-flex-align: center;
      align-items: center;
      -ms-flex-pack: center;
      display: -ms-flexbox;
      display: flex;
      font-size: 2rem;
      color: #888888;
    }

    .left_Title {
      width: 54px;
      height: 100%;
      background: #ffffff;
      margin-right: 2px;
      padding-top: 27px;
      display: flex;
      justify-content: flex-end;

      p:nth-child(1) {
        width: 24px;
        color: var(--themeColor);
        font-size: 20px;
        line-height: 24px;

        i {
          font-size: 24px;
        }
      }

      p:nth-child(2) {
        width: 8px;
        height: 162px;
        background: var(--themeColor);
        margin-left: 10px;
      }
    }

    .m_content {
      height: 100%;
      display: flex;
      width: 100%;
      overflow-x: auto;

      .history {
        width: 100%;
        //overflow-x: scroll;
        height: 100%;

        .nodete {
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 2rem;
          color: #888888;
        }

        .total {
          width: 30px;
          line-height: 30px;
          margin-top: 20px;
          height: calc(100% - 20px);
          margin-right: 10px;
          font-size: 1.5rem;
          color: #888888;
        }

        .preface_box {
          height: 100%;
          display: flex;
          flex-direction: column;
          margin-right: 5px;

          .preface_box_picture {
            height: 100%;
            display: flex;
            flex-wrap: wrap;
            padding: 0.2rem;
            margin-right: 0.3rem;

            .picture_size {
              width: 10rem;
              height: 6rem;
              padding: 0.2rem;
              overflow: hidden;
              cursor: pointer;

              img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                object-position: center;
              }
            }
          }

          .preface_box_video {
            height: 100%;
            display: flex;
            flex-wrap: wrap;
            padding: 0.2rem;
            margin-right: 0.3rem;

            .video_size {
              width: 10rem;
              height: 6rem;
              padding: 0.2rem;
              overflow: hidden;
              position: relative;
              cursor: pointer;

              img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                object-position: center;
              }

              i {
                position: absolute;
                font-size: 3rem;
                color: #ffffff;
                top: calc(calc(100% - 3rem) / 2);
                left: calc(calc(100% - 4.5rem) / 2);
              }
            }

            .video_size::before {
              content: "";
              position: absolute;
              top: 0.2rem;
              left: 0.2rem;
              bottom: 0.2rem;
              right: 0.2rem;
              width: 100%;
              height: 100%;
              background-color: rgba(0, 0, 0, 0.5); /* 设置遮罩层的背景颜色和透明度 */
            }
          }

          .preface_box_audio {
            height: 100%;

            .audio_size {
              line-height: 2.8rem;
              height: calc(100% - 0.8rem);
              padding: 1rem 1rem 1.2rem 1rem;
              margin: 0.4rem 0.2rem;
              background: #ededed;
              position: relative;
              font-size: 2rem;
              color: #888888;
              overflow: hidden;
              border-radius: 0.2rem;
              writing-mode: vertical-lr;
              white-space: pre-wrap;
              cursor: pointer;

              span {
                writing-mode: vertical-lr;
                white-space: pre-wrap;
                display: flex;
              }

              i {
                position: absolute;
                top: 1rem;
                left: calc(calc(100% - 2.5rem) / 2);
                font-size: 2.5rem;
                cursor: pointer;
              }
            }
          }
        }

        .main {
          background: #ffffff;
          padding: 10px;
          margin-right: 2px;

          p {
            writing-mode: vertical-lr;
            margin-right: 2px;
            white-space: pre-wrap;
            height: 95%;
            font-size: 2rem;
            color: #888888;

            span {
              writing-mode: vertical-lr;
              margin-bottom: 10px;
              white-space: pre-wrap;
            }
          }

          .om {
            margin-top: 30px;
            line-height: 30px;
          }

          .tm {
            //margin-top: 5px;
          }

          .ly {
            border-right: 1px solid var(--themeColor);
            line-height: 30px;
            margin-top: 30px;
            height: calc(100% - 25px);
            font-size: 1.4rem;
          }
        }
      }
    }

    .m_content::-webkit-scrollbar {
      /*滚动条整体样式*/
      width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
      height: 8px;
    }

    .m_content::-webkit-scrollbar-thumb {
      /*滚动条里面小方块*/
      border-radius: 5px;
      -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      background: rgba(0, 0, 0, 0.2);
    }

    .m_content::-webkit-scrollbar-track {
      /*滚动条里面轨道*/
      -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      border-radius: 0;
      background: rgba(0, 0, 0, 0.1);
    }

    .page {
      width: 50px;
      height: 100%;
    }
  }
}
</style>

